module.exports = __webpack_public_path__ + "static/media/10.db108516.jpg";